/* Overrides the position of the tooltip due to a potential bug in the `react-tooltip` package.
 * It seems to position the tooltip according to the window offset instead of the parent.
 * This provides an offset to the component that substracts the parent's coords to the
 * initial tooltip coords. Might not be needed if we update to `react-tooltip` v5.
 */

export const createOverrideTooltipPosition =
  (containerRef: React.RefObject<HTMLElement>) =>
  (coords: { left: number; top: number }): { left: number; top: number } => {
    if (containerRef.current) {
      const bbox = containerRef.current.getBoundingClientRect();
      return { left: coords.left - bbox.left, top: coords.top - bbox.top };
    }
    return coords;
  };
